import newUnitType from './new-unit-type.vue'

export default newUnitType
